<template>
  <div class="flex">
    <section class="common-sub-top container">
      <section class="top-info-wrap">
        <div class="prev-wrap">
          <a @click="pageBefore()" class="prev"></a>
          <span class="name">업데이트 이력</span>
        </div>
      </section>
    </section>
    <div class="content">
      <div class="update-list">
        <div v-for="item in updates" :key="item.version" class="update-card">
          <div class="version-header">
            <span class="version">{{ item.version }}</span>
            <span class="date">{{ item.date }}</span>
          </div>
          <ul class="change-list">
            <li v-for="change in item.changes" :key="change" v-html="'- ' + change"></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      updates: [
        {
          version: '[개선] 접수 리스트 화면',
          date: '2025.12.18',
          changes: ['에이전트 통신 모듈 안정화 및 성능 개선.<br>- 접수 리스트 화면 렌더링 성능 최적화.']
        },
        {
          version: '[설정] 접수 정보 표시 여부  ',
          date: '2025.10.15',
          changes: ['환자 개인정보 보호 강화를 위해, 접수 정보 표시 여부 설정이 추가되었습니다.<br>- 해당 옵션을 비활성화하면, 환자 목록에서 접수 정보 칼럼이 표시되지 않게 됩니다.']
        },
        { version: '[설정] 처방 아이콘 표시 설정  ', date: '2025.08.06', changes: ['대기환자목록의 처방 용법 컬럼 표시 여부.'] },
        { version: '[환자 차트 보기] 처방된 주사의 용법 표기', date: '2025.07.30', changes: ['청구 코드 컬럼 삭제 . 용법 컬럼으로 변경. '] },
        { version: '[대기환자 목록] 주사,검사,방사선,물리치료 처방 용법 추가', date: '2025.07.30', changes: ['처방 용법과 관련된 이미지 활성,비활성 추가.'] },
        { version: '[대기환자 목록] 검진 환자일 경우 추가 표시', date: '2025.07.30', changes: ['ex) 국가 검진시 초/재진 하단에 검진으로 표기.'] }
      ]
    };
  },
  methods: {
    pageBefore() {
      this.$router.go(-1);
    }
  }
};
</script>
<style scoped>
.flex {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
.content {
  flex: 1;
}
.update-list {
  padding: 20px;
  font-family: sans-serif;
}

.update-card {
  border: 2px solid #ff6357;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 16px;
  background: #fff;
  width: 100%;
}

.version-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.version {
  color: #000;
  font-size: 14px;
}

.date {
  color: #888;
  font-size: 12px;
}

.change-list {
  padding-left: 20px;
  list-style: disc;
}
.change-list li {
  font-size: 16px;
}
</style>
